module.exports = __webpack_public_path__ + "static/img/Kiitoskortti_Avecor_atte-palonen_A4.5b3fc96.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/salesperson-leaflets/Kiitoskortti_Avecor_atte-palonen_A4.pdf
// module id = RqSd
// module chunks = 22